import React, { FC } from 'react';

import { Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

export const SIDE_NAVIGATION_DATA_TEST_ID = 'SideNavigationLayoutLoader';

export const SideNavigationLayoutLoader: FC = () => (
  <Flex
    width="220px"
    height="100%"
    backgroundColor={theme.colors.charcoal050}
    flexDirection="column"
    justifyContent="space-between"
    data-testid={SIDE_NAVIGATION_DATA_TEST_ID}
  />
);
